import React from 'react';
import { createRoot } from 'react-dom/client';
import PokerLayout from './PokerLayout.mjs';
import ErrorPlaceholder from "./ErrorPlaceholder.mjs";

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('poker-live-api-app');

  if (container) {
    const root = createRoot(container);
    const propertyCode = JSON.parse(container.dataset.propertyCode);
    const keys = {
      WCB: "6128ad8a-94ab-4413-8fed-f8ab6d622a9b",
      MCC: "d98cec29-8a1e-449f-851f-4bc349f3bff4",
    };
    const key = keys[propertyCode];
    const cashGamesApi = "https://pokeratlas.com/api/offered_cash_games?key=" + key;
    const liveCashGamesApi = "https://pokeratlas.com/api/live_cash_games?key=" + key;
    const liveTournaments = "https://pokeratlas.com/api/live_tournaments?key=" + key + "&include_all=true&start_date_range=" + new Date().toISOString();

    // renderApp();
    Promise.all([
      fetch(cashGamesApi),
      fetch(liveCashGamesApi),
      fetch(liveTournaments),
    ])
      .then((responses) => {
        return Promise.all(responses.map((r) => r.json()));
      })
      .then((json) => {
        const keys = ['cashGames', 'liveCashGames', 'liveTournaments'];
        let jsonResponse = new Map();

        for (let i = 0; i < json.length; i++) {
          jsonResponse.set(keys[i], json[i]);
        }

        root.render(<PokerLayout data={jsonResponse} propertyCode={propertyCode} />);
      })
      .catch((error) => {
        console.error("An error occurred:", error);
        root.render(<ErrorPlaceholder />);
      })
    ;
  }
});
